import { IComponentOptions } from "angular"
import { RelationshipEditComponentController } from "./controller"

export const vsComponentName = "relationshipEditComponent"

export const relationshipEditComponentOptions: IComponentOptions = {
  controller: RelationshipEditComponentController,
  controllerAs: "relationshipEditController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    "model": "<",
    //"contractType": "<",
    "contract": "<"
  }
}